var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowUturnLeftOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.15077 3.24076C9.5701 3.60018 9.61866 4.23148 9.25924 4.65081L7.6742 6.50002L11.25 6.50002C14.1495 6.50002 16.5 8.85052 16.5 11.75C16.5 14.6495 14.1495 17 11.25 17H9.99998C9.4477 17 8.99998 16.5523 8.99998 16C8.99998 15.4477 9.4477 15 9.99998 15H11.25C13.0449 15 14.5 13.5449 14.5 11.75C14.5 9.95509 13.0449 8.50002 11.25 8.50002L7.6742 8.50002L9.25924 10.3492C9.61866 10.7686 9.5701 11.3999 9.15077 11.7593C8.73145 12.1187 8.10015 12.0701 7.74073 11.6508L4 7.50003L7.74073 3.34923C8.10015 2.9299 8.73145 2.88134 9.15077 3.24076Z",
  fill: "currentColor"
})));
export { SvgArrowUturnLeftOutline20 as ReactComponent };